import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CancellationPolicyOption } from '@curbnturf/entities';
import { getCancellationPolicyString } from '@curbnturf/helpers';

@Component({
  selector: 'curbnturf-cancellation-policy-list',
  templateUrl: './cancellation-policy-list.component.html',
  styleUrls: ['./cancellation-policy-list.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass],
})
export class CancellationPolicyListComponent {
  // Options are: ['easy', 'moderate', 'strict', 'exclusive']
  @Input() policy: 'easy' | 'moderate' | 'strict' | 'exclusive' | CancellationPolicyOption;
  @Input() showAll: boolean = false;

  getCancellationPolicyString = getCancellationPolicyString;
  @Input() finePrint: boolean = true;
}
